module.exports = __webpack_public_path__ + "img/help_lines_final.26dfd6ef.jpg";